import { Rocket } from "lucide-react";

export const PageHeader = ({ icon: Icon = Rocket, title, subtitle }) => {
  return (
    <header className="mb-8 md:mb-12" data-testid="page-header">
      {/* PMA Project Branding - Larger for mobile */}
      <div className="mb-4">
        <span className="text-sm md:text-base font-heading font-bold uppercase tracking-[0.25em] text-cosmic-blue">
          The PMA Project
        </span>
      </div>
      
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 rounded-xl bg-cosmic-blue/20 border border-cosmic-blue/30">
          <Icon className="w-6 h-6 text-cosmic-blue" strokeWidth={1.5} />
        </div>
        <h1 className="font-heading font-bold text-2xl md:text-3xl tracking-tight uppercase text-white">
          {title}
        </h1>
      </div>
      {subtitle && (
        <p className="text-slate-400 md:text-lg">
          {subtitle}
        </p>
      )}
    </header>
  );
};
